export enum Status {
    CREATED = 'CREATED',
    PENDING = 'PENDING',
    MODIFY = 'MODIFY',
    DECLINED = 'DECLINED',
    APPROVED = 'APPROVED'
}
